import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgCommonModule } from '../../../shared/svg/svg-common.module';
import { DeviceInformationService } from '../../device-information.service';

import { GetMobileLabelCreateNotificationDataResponse, MobileLabelCreateNotificationDataService } from './mobile-label-create-notification.data.service';

@Component({
    selector: 'app-mobile-label-create-notification',
    templateUrl: './mobile-label-create-notification.component.html',
    styleUrls: ['./mobile-label-create-notification.component.less'],
    imports: [
        CommonModule,
        SvgCommonModule,
    ],
})
export class MobileLabelCreateNotificationComponent implements OnInit {

	public android: boolean = this.deviceInformationService.android();
	public ios: boolean = this.deviceInformationService.iOS();

	public hide: boolean = false;

	public hideFromConfig$: Observable<GetMobileLabelCreateNotificationDataResponse> = this.mobileLabelCreateNotificationDataService.getMobileLabelCreateNotificationData();


	constructor(
		private deviceInformationService: DeviceInformationService,
		private mobileLabelCreateNotificationDataService: MobileLabelCreateNotificationDataService,
	) { }

	public ngOnInit(): void {
	}

}
